import IcoMoon from '@/components/IcoMoon'
import { Stack } from '@/components/Layout'
import { SizeInBytes } from '@/components/SizeInBytes'
import * as styles from './style'

export interface Props {
  fileName: string
  sizeInBytes: number
  url: string
}

export function Attachment({ fileName, url, sizeInBytes }: Props): JSX.Element {
  return (
    <Stack x alignItems="center" justifyContent="flex-start" className={`${styles.root} mb-sm`}>
      <IcoMoon className="mr-xs" icon="file-text" size={22} />
      <a href={url} target="_blank" className="mr-xs">
        {fileName}
      </a>
      <SizeInBytes bytes={sizeInBytes} className={styles.fileSize} />
    </Stack>
  )
}
